enum DocumentStatus {
	GENERATING = 'generating',
	GENERATED = 'generated',
	QUEUED = 'queued'
}

export default DocumentStatus
